import LaptopIcon from '@mui/icons-material/Laptop';
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import LaptopWindowsIcon from '@mui/icons-material/LaptopWindows';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import ReplayIcon from '@mui/icons-material/Replay';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import TabletAndroidIcon from '@mui/icons-material/TabletAndroid';
import TabletMacIcon from '@mui/icons-material/TabletMac';
import Card from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import React, { IframeHTMLAttributes, ReactNode, useState } from 'react';
import { uiExternalUrls } from '../states';

interface IDimension {
  width: number;
  height: number;
  name: string;
  icon: ReactNode;
}
const DIMENSIONS: IDimension[] = [
  {
    name: 'Google Chromebook Pixel',
    width: 2560,
    height: 1700,
    icon: <LaptopChromebookIcon style={{fontSize: 14}}/>
  },

  {
    name: 'Acer Chromebook',
    width: 1366,
    height: 768,
    icon: <LaptopChromebookIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Amazon Fire',
    width: 1024,
    height: 600,
    icon: <LaptopIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iMac 21.5 in',
    width: 4096,
    height: 2304,
    icon: <LaptopMacIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iMac 27 in',
    width: 5120,
    height: 2880,
    icon: <LaptopMacIcon style={{fontSize: 14}}/>
  },

  {
    name: 'Apple iPad 1 & 2',
    width: 768,
    height: 1024,
    icon: <TabletMacIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPad 1 & 2 Pro',
    width: 1024,
    height: 1366,
    icon: <TabletMacIcon style={{fontSize: 14}}/>
  },

  {
    name: 'Apple iPad 3 & 4',
    width: 1180,
    height: 820,
    icon: <TabletMacIcon style={{fontSize: 14}}/>
  },

  {
    name: 'Apple iPad Mini',
    width: 768,
    height: 959,
    icon: <TabletMacIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPad Pro 12.9',
    width: 1024,
    height: 1366,
    icon: <TabletMacIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPhone 5/SE',
    width: 320,
    height: 568,
    icon: <PhoneIphoneIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPhone 6/7/8',
    width: 375,
    height: 667,
    icon: <PhoneIphoneIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPhone 6/7/8 Plus',
    width: 414,
    height: 736,
    icon: <PhoneIphoneIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple IPhone X',
    width: 375,
    height: 812,
    icon: <PhoneIphoneIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPhone 11',
    width: 414,
    height: 896,
    icon: <PhoneIphoneIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPhone 12',
    width: 390,
    height: 844,
    icon: <PhoneIphoneIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPhone 12 Mini',
    width: 360,
    height: 780,
    icon: <PhoneIphoneIcon style={{fontSize: 14}}/>
  },
  {
    name: 'Apple iPhone 12 Pro',
    width: 390,
    height: 844,
    icon: <PhoneIphoneIcon style={{fontSize: 14}}/>
  },

  {
    width: 411,
    height: 731,
    name: 'Google IPixel 2',
    icon: <PhoneAndroidIcon style={{fontSize: 14}}/>
  },
  {
    width: 411,
    height: 823,
    name: 'Google IPixel 2 XL',
    icon: <PhoneAndroidIcon style={{fontSize: 14}}/>
  },
  {
    width: 1024,
    height: 600,
    name: 'Google Nest Hub',
    icon: <TabletAndroidIcon style={{fontSize: 14}}/>
  },
  {
    width: 1280,
    height: 800,
    name: 'Google Nest Hub Max',
    icon: <TabletAndroidIcon style={{fontSize: 14}}/>
  },
  {
    width: 360,
    height: 640,
    name: 'Moto G4',
    icon: <SmartphoneIcon style={{fontSize: 14}}/>
  },
  {
    width: 360,
    height: 640,
    name: 'Samsung Galaxy S5',
    icon: <SmartphoneIcon style={{fontSize: 14}}/>
  },
  {
    width: 280,
    height: 653,
    name: 'Samsung Galaxy Fold',
    icon: <SmartphoneIcon style={{fontSize: 14}}/>
  },
  {
    width: 540,
    height: 720,
    name: 'Windows Surface Duo',
    icon: <LaptopWindowsIcon style={{fontSize: 14}}/>
  },

];

export default function ContentPreview(props: IframeHTMLAttributes<HTMLIFrameElement> & { target: string }) {
  const { title, src, target } = props;
  const [frameSrc, setFrameSrc] = useState(src);
  const [dimensions, setDimensions] = useState<{ width: number, height: number; name: string }>(DIMENSIONS[DIMENSIONS.findIndex(d => d.name === 'Apple IPhone X')]);

  const handleReload = () => {
    if (src === uiExternalUrls.loading) {
      return;
    }
    setFrameSrc(uiExternalUrls.loading);
    setTimeout(() => {
      setFrameSrc(src);
    }, 800);
  };

  return (
    <Grid container direction="column">
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Link href={src} target={target} color="primary" style={{ fontSize: 10, padding: 4 }}>{title}</Link>
        <IconButton onClick={handleReload} size="small" color="primary"><ReplayIcon
          style={{ fontSize: 12 }}/></IconButton>
      </Grid>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <FormControl>
          <Select
            labelId="dimensions-select-label"
            id="dimensions-select"
            value={dimensions.name}
            style={{ fontSize: 10 }}
            onChange={(e) => {
              const index = DIMENSIONS.findIndex(d => d.name === e.target.value);
              if (index > -1) {
                setDimensions(DIMENSIONS[index]);
                handleReload();
              }
            }}
          >
            {DIMENSIONS.map((d) => <MenuItem key={d.name} value={d.name}>
              <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                <Typography variant="body2" style={{marginRight: 8}}>
                  {d.icon} {d.name}
                </Typography>
                <Typography variant="caption">
                  {d.width} x {d.height}
                </Typography>
              </Grid>
            </MenuItem>)}
          </Select>
        </FormControl>
      </Grid>

      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Card>
          <iframe
            {...props}
            {...dimensions}
            src={frameSrc}
            style={{ border: 0 }}
          />
        </Card>
      </Grid>
    </Grid>
  );
}
